import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ga4SendPageView, initGa4AfterInteraction } from "@/lib/analytics/ga4";

/** SPA re-mounts (e.g. React Strict Mode) can repeat the same path in quick succession. */
let __ga4LastVirtualPvPath: string | null = null;
let __ga4LastVirtualPvAt = 0;
const VIRTUAL_PV_DEDUP_MS = 120;

/**
 * Registers the first-interaction GA4 loader on mount and sends `page_view`
 * on each route change. Must render under `BrowserRouter`.
 *
 * page_view events before the script loads are queued in `window.dataLayer`
 * via the gtag stub and replayed automatically when gtag.js initializes.
 */
export function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    initGa4AfterInteraction();
  }, []);

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    const now = Date.now();
    if (
      __ga4LastVirtualPvPath === path &&
      now - __ga4LastVirtualPvAt < VIRTUAL_PV_DEDUP_MS
    ) {
      return;
    }
    __ga4LastVirtualPvPath = path;
    __ga4LastVirtualPvAt = now;
    ga4SendPageView(path);
  }, [location.pathname, location.search]);

  return null;
}
